module.exports = __webpack_public_path__ + "media/images/flags/32/Slovenia-1e9a825de1d3985fb041a002ce42dec5.png";